import { createApp } from 'vue'
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import 'bootstrap-icons/font/bootstrap-icons.css';
import vuetify from "./plugins/veutify";
import { loadFonts } from "./plugins/webfontloader";
import router from "./router/route.js";
import i18n from './plugins/i18n'; 
import { createPinia } from 'pinia'
import '@/assets/freakflags.css' 

// Disable console.* on non-localhost
const isLocalhost = window.location.hostname === 'localhost';
if (!isLocalhost) {
  Object.keys(console).forEach(method => {
    console[method] = function () {};
  });
}
loadFonts();
const pinia = createPinia()

createApp(App)
.use(router)
.use(vuetify)
.use(i18n)
.use(pinia)
.mount('#app')
